import * as t from "io-ts";

export const FinanceProvider = t.union([
  t.literal("allium"),
  t.literal("demo"),
  t.literal("etika"),
  t.literal("humm"),
  t.literal("novuna"),
  t.literal("omni"),
  t.literal("propensio"),
]);

export type FinanceProvider =
  | "allium"
  | "demo"
  | "etika"
  | "humm"
  | "novuna"
  | "omni"
  | "propensio";
